import { OtherProp } from "@/react/components/shared/BuilderUI/constants/PropCategories";
import type { EditorFieldProps } from "../DefaultEditorFields";
import type { TabGroups } from "../useCategorizedBlockProps";
import {
  FIELD_TO_STYLE_CATEGORY_MAP,
  META_CATEGORY_TO_STYLE_CATEGORY_MAP,
} from "./constants";

const extractFieldName = (fieldPath: string): string => {
  if (!fieldPath?.trim()) {
    return "unknown";
  }
  const parts = fieldPath.trim().split(".").filter(Boolean);
  if (parts.length === 0) {
    return "unknown";
  }
  return parts[parts.length - 1];
};

export const groupFieldsByStyleCategory = (
  nestedGroups: TabGroups,
  categories: string[],
): Record<string, EditorFieldProps[]> => {
  const remappedGroups: Record<string, EditorFieldProps[]> = {};

  categories.forEach(category => {
    const groups = nestedGroups[category] || {};

    Object.entries(groups).forEach(([metaCategory, fields]) => {
      fields.forEach(field => {
        const fieldName = extractFieldName(field.name);

        const styleCategory =
          FIELD_TO_STYLE_CATEGORY_MAP[fieldName] ||
          META_CATEGORY_TO_STYLE_CATEGORY_MAP[metaCategory] ||
          OtherProp.name;

        if (!remappedGroups[styleCategory]) {
          remappedGroups[styleCategory] = [];
        }
        remappedGroups[styleCategory].push(field);
      });
    });
  });

  return remappedGroups;
};
